<template>
  <div>
    <div class="provider-info">
      <img src="../logos/microsoft-logo.svg">
    </div>
    <p>
      If you use any Microsoft email service (Microsoft 365, Exchange Server, Outlook Web Access), 
      ask your IT administrator to create an auto-forwarding rule
      from <strong>{{forwardingFromAddress}}</strong> to:
    </p>
    <clipboard-text :text="incomingEmailAddress" class="incoming-email-address" />
    <p><br></p>
    <p>
      Otherwise, click on your specific Microsoft product for documentation on auto-forwarding emails
      using the forwarding address above.
    </p>
    <p><br></p>
    <el-collapse v-model="curSelection">
      <el-collapse-item name="365">
        <template #title>
          <div>
            <div class="el-collapse-item__image">
              <img src="../logos/ms-square-logo.png">
            </div>
            <span class="el-collapse-item__title">Microsoft 365</span>
          </div>
        </template>
        <p> 
          For Microsoft 365 users, here's how to
          <a href="https://docs.microsoft.com/en-us/microsoft-365/admin/email/configure-email-forwarding?view=o365-worldwide" target="_blank" class="just-a-link">configure email forwarding</a>.
        </p>
        <p><br></p>
        <p class="small">
          <strong>Note:</strong> Some Microsoft 365 accounts block automatic email forwarding as part of their outbound spam protection. 
          If external forwarding is disabled for your Microsoft 365 account, you will see a bounce message in your 
          inbox after attempting to set up forwarding to DoneDone. The text of the bounce will include this line: 
        </p>
        <p><br></p>
        <code>550 5.7.520 Access denied, Your organization does not allow external forwarding. Please contact your administrator for further assistance. AS(7555)</code>    
        <p><br></p>
        <p>
          To enable external forwarding in these cases, refer to this link from Microsoft:
          <a href="https://docs.microsoft.com/en-us/microsoft-365/security/office-365-security/external-email-forwarding?view=o365-worldwide" target="_blank" class="just-a-link">
            Control automatic external email forwarding in Microsoft 365</a>.
        </p>
      </el-collapse-item>
      <el-collapse-item name="Exchange">
        <template #title>
          <div>
            <div class="el-collapse-item__image">
              <img src="../logos/ms-exchange-logo.svg">
            </div>
            <span class="el-collapse-item__title">Microsoft Exchange Server</span>
          </div>
        </template>
        <p> 
          For Microsoft Exchange Server users, here's how to
          <a href="https://docs.microsoft.com/en-us/exchange/recipients/user-mailboxes/email-forwarding?view=exchserver-2019" target="_blank" class="just-a-link">configure email forwarding</a>.
          You can choose your specific version of Exchange from the <strong>Version</strong> dropdown on the left-side of this page.
        </p>
      </el-collapse-item>
      <el-collapse-item name="OWA">
        <template #title>
          <div>
            <div class="el-collapse-item__image">
              <img src="../logos/ms-outlook-logo.svg">
            </div>
            <span class="el-collapse-item__title">Outlook Web Access</span>
          </div>
        </template>
        <p>
          <strong>For Outlook Web Access</strong>, create a <strong>redirect</strong> rule rather than 
          a <strong>forwarding</strong> rule.
          <a href="https://support.microsoft.com/en-us/office/use-rules-to-automatically-forward-messages-45aa9664-4911-4f96-9663-ece42816d746" target="_blank" class="just-a-link">Scroll to the bottom of this page</a> for instructions.
        </p>
      </el-collapse-item>
    </el-collapse>
    <dd-button
      :color="ColorAssistant.MailboxColor"
      size="large"
      full-width
      @click="$emit('completion-clicked')"
    >I've set up the auto-forwarding rule. Verify auto-forwarding is working!</dd-button>
  </div>
</template>
<script lang="ts">
/* General */
import { defineComponent } from 'vue'

/* Mixins */

/* Components */

/* Helpers */
import ColorAssistant from '@/helpers/color-assistant'

/* Data types */

/* API */

export default defineComponent({
  name: 'MailboxVerificationInstructionsMicrosoft',
  props: {
    incomingEmailAddress: {
      type: String,
      required: true,
    },
    forwardingFromAddress: {
      type: String,
      required: true,
    },
  },
  emits: ['completion-clicked'],
  data() {
    return {
      ColorAssistant,
      curSelection: '',
    }
  },
})
</script>

<style lang="scss">
// Shared from root mailbox-verification-auto-forwarding.vue
</style>
